// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import ContactTypeDto from 'common/dto-types/contacts/contact-type-dto';
import { SortingParam, SortingType } from 'components/base-table/dto';
import { DefaultVisibleContactTypeColumns } from 'pages/contact-types-list-page/contact-types-column-config';
import { Filters } from 'react-table';

type ContactTypeSliceStates = {
    data?: ContactTypeDto;
    isFormOpen: boolean;
    filters: Filters<any>;
    sorting: SortingParam;
    visibleColumns: Array<string>;
};

const initialState: ContactTypeSliceStates = {
    isFormOpen: false,
    filters: [],
    sorting: { sortingType: SortingType.Ascending, sortBy: 'name', searchTerm: '' },
    visibleColumns: DefaultVisibleContactTypeColumns,
};

const contactType = createSlice({
    name: 'contactType',
    initialState,
    reducers: {
        setContactType(state, action) {
            state.data = action.payload;
        },

        openContactTypeForm(state) {
            state.isFormOpen = true;
        },

        closeContactTypeForm(state) {
            state.data = undefined;
            state.isFormOpen = false;
        },

        setContactTypeListPersistence(state, action) {
            state.filters = action.payload.filters;
            state.sorting = action.payload.sorting;
        },

        setContactTypeColumnsPersistence(state, action) {
            state.visibleColumns = action.payload;
        },
    },
});

export default contactType.reducer;

export const {
    openContactTypeForm,
    closeContactTypeForm,
    setContactType,
    setContactTypeListPersistence,
    setContactTypeColumnsPersistence,
} = contactType.actions;
